import React, { Component, Fragment } from 'react';

class DriverSignature extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                {this.props.imagePath ? (
                    <div>
                        <div className="row pb-3 mt-4">
                            <div className="col-12">
                                <h6 className="py-2 pl-2 cw-bg-grey text-white">Driver signature</h6>
                            </div>
                        </div>
                        <div className="col-md-4 mb-2">
                            <img src={this.props.imagePath} className="img-fluid" alt="" />
                        </div>
                        {this.props.driver !== null ? (
                            <div className="row">
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        value={this.props.driver.first_name + ' ' + this.props.driver.last_name}
                                        className="form-control"
                                        disabled
                                    />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    ''
                )}
            </Fragment>
        );
    }
}

export default DriverSignature;
